import { ReactNode } from 'react'

interface SalesChannelsConnectorProps {
  type: string
  icon?: string
  onBoxClick?: () => void
  active: boolean
  title: string
  imgIcon?: string
  buttons: [ReactNode, (e: any) => void][]
}

export const SalesChannelsConnector = ({
  type,
  icon,
  onBoxClick,
  active,
  title,
  imgIcon,
  buttons,
}: SalesChannelsConnectorProps): JSX.Element => {
  const returnCursorClassAccordingConnectorType = (type: string) => {
    let styles = undefined
    switch (type) {
      case 'Shopify':
        styles = {}
        break
      case 'CardTrader':
        styles = {}
        break
      default:
        styles = {}
    }

    return { ...styles, ...{ cursor: onBoxClick ? 'pointer' : 'default' } }
  }

  if (active) {
    return (
      <div
        onClick={onBoxClick}
        className={`sales-channel-connector active `}
        style={returnCursorClassAccordingConnectorType(type)}
      >
        <div>
          <h6 className="m-0 p-0">{title}</h6>
        </div>
        <div className="d-flex flex-row align-items-center justify-content-between pt-3">
          <div>
            {buttons?.map((button, index) => (
              <div
                onClick={() => button[1]({ channel: type, channelInstance: title })}
                style={{ cursor: 'pointer' }}
                key={index}
              >
                {button[0]}
              </div>
            ))}
          </div>
          {icon ? <i className={icon}></i> : <img src={imgIcon} className="svg-icon active" />}
        </div>
      </div>
    )
  } else {
    return (
      <div
        onClick={onBoxClick}
        className="sales-channel-connector inactive"
        style={returnCursorClassAccordingConnectorType(type)}
      >
        <div className="d-flex flex-column justify-content-between">
          <div className="d-flex flex-row align-items-center justify-content-between">
            <h6 className="m-0 p-0">{title}</h6>
            {icon ? <i className={icon}></i> : <img src={imgIcon} className="svg-icon inactive" />}
          </div>
        </div>
      </div>
    )
  }
}
